import { memo } from "react"
import { Box, Typography } from "@mui/material"
import { AutoAwesome } from "@mui/icons-material"
import { styles } from "./PageHeader.styles"

export const PageHeader = memo(
  ({
    title = "",
    stepTitle = "",
    subtitle = "",
    stepper,
    rightContent,
    showSpark = false,
    sx,
  }) => {
    return (
      <Box sx={[styles.headerRow, sx]}>
        <Box sx={styles.textContainer}>
          <Box sx={styles.titleRow}>
            {title && (
              <Typography variant="title" sx={styles.title}>
                {title}
                {showSpark && !stepTitle && (
                  <AutoAwesome sx={styles.sparkIcon} />
                )}
              </Typography>
            )}
            {title && stepTitle && (
              <Typography variant="title" sx={styles.titleSeparator}>
                {" – "}
              </Typography>
            )}
            {stepTitle && (
              <Typography variant="title" sx={styles.stepTitle}>
                {stepTitle}
                {showSpark && <AutoAwesome sx={styles.sparkIcon} />}
              </Typography>
            )}
          </Box>
          {subtitle && (
            <Typography variant="body2" sx={styles.pageSubtitle}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {stepper && <Box sx={styles.stepperWrapper}>{stepper}</Box>}
        {rightContent && <Box sx={styles.rightContent}>{rightContent}</Box>}
      </Box>
    )
  }
)

export default PageHeader
